/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Franchise_Create_NameInputs */

const cs_franchise_create_name = /** @type {(inputs: Franchise_Create_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Název kanceláře`)
};

const en_franchise_create_name = /** @type {(inputs: Franchise_Create_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Office name`)
};

/**
* | output |
* | --- |
* | "Office name" |
*
* @param {Franchise_Create_NameInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const franchise_create_name = /** @type {((inputs?: Franchise_Create_NameInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Franchise_Create_NameInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_franchise_create_name(inputs)
	return cs_franchise_create_name(inputs)
});